// extracted by mini-css-extract-plugin
module.exports = {"createNavBar":"CrudCreateComponent_createNavBar__2wU2s","tabs":"CrudCreateComponent_tabs__KohaQ","btnExpand":"CrudCreateComponent_btnExpand__1UWBy"};